/* eslint-disable max-len */
/* eslint-disable react/no-unknown-property */
/* jscs:disable maximumLineLength */
import React, { PureComponent } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

class LogOut extends PureComponent {
  render = () => (
    <SvgIcon viewBox="-4 -4 24 24" {...this.props}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-62.000000, -652.000000)" fill="#84909E">
          <g transform="translate(38.000000, 347.000000)">
            <path d="M45,305 L45,322 L39.4528302,322 L39.4528302,320.380952 L43.4148302,320.38 L43.4148302,306.619 L39.4528302,306.619048 L39.4528302,305 L45,305 Z M30.5998856,307.232148 L31.7205832,308.376988 L27.102,313.095148 L41.0377358,313.095238 L41.0377358,314.714286 L27.102,314.714148 L31.7205832,319.432536 L30.5998856,320.577376 L25.221,315.082148 L25.1886792,315.119048 L24,313.904762 L24.9963979,312.956346 L30.5998856,307.232148 Z" />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export default LogOut;
